<template>
  <div class="shop-table__line">
    <div class="add-to-cart" :style="addToCartColor != '' ? {'border-color': addToCartColor} : ''">
      <input
        type="number"
        :min="minQuantityValue"
        :max="maxQuantity"
        :step="buyingStep"
        name="quantity"
        :value="inputValue"
        ref="add_to_cart_input"
        @invalid="customValidation"
        @change="checkBuyingStep"
      />
      <span v-if="measurementUnit && showMeasurementUnit">{{ measurementUnit }}</span>
      <button type="submit" name="submit" :style="addToCartColor != '' ? {'background-color': addToCartColor} : ''">{{ translations.addToCart }}</button>
    </div>
    <div class="loader" v-if="isLoading">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
form {
  position: relative;

  .add-to-cart {
    display: flex;
    border: 0.1rem solid;
    border-radius: 0.5rem;
    margin: 0.3rem 0;
    overflow: hidden;
    align-items: stretch;

    input {
      padding: 0.3rem;
      text-align: center;
      overflow: hidden;
      width: 6rem;
      background-color: $color-white;
    }

    button {
      font-size: 1.6rem;
      letter-spacing: 0.16rem;
      line-height: 1.4rem;
      padding: 0.3rem;
      text-transform: uppercase;
      font-weight: bold;
      width: 6rem;
    }
  }

  .loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(54, 54, 54, 0.315);
  }
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 35%;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
}
</style>
<script>
export default {
  name: "WellsAddToCart",
  props: {
    id: Number,
    minQuantity: Number,
    maxQuantity: Number,
    isLoading: Boolean,
    measurementUnit: String,
    buyingStep: Number,
    addToCartColor: String
  },
  methods: {
    getMinQuantity(){
      if(ws_vue_store.enable_buying_step != '1'){ return this.minQuantity }

      return this.buyingStep;
    },
    customValidation(){
      this.checkBuyingStep();
      let el = this.$refs.add_to_cart_input;
      let max = el.getAttribute('max');
      let value = el.value;
      if(parseInt(value) > parseInt(max)){
        el.setCustomValidity(ws_vue_store.translations.add_to_cart_invalid_message)
      } else {
        el.setCustomValidity('');
      }
    },
    checkBuyingStep(){
      let step = this.minQuantityValue;
      let quantity = Number(this.$refs.add_to_cart_input.value);
      this.setInputValue(quantity, step, this.maxQuantity);
    },
    setInputValue(quantity, step, maxQuantity){
      if(quantity % step != 0 || quantity > maxQuantity){
        if(Math.ceil(quantity / step) * step > maxQuantity){
          let qty = Math.ceil(maxQuantity / step);
          let calculation = qty * step <= maxQuantity ?  qty * step : qty * step - step;
          this.$refs.add_to_cart_input.value =  calculation;
          this.inputValue = calculation;
        } else {
          let calculation = Math.ceil(quantity / step) * step;
          this.$refs.add_to_cart_input.value = calculation;
          this.inputValue = calculation;
        }
      } else {
        this.$refs.add_to_cart_input.value = quantity;
        this.inputValue = quantity;
      }
    }
  },
  data() {
    return {
      minQuantityValue: this.getMinQuantity(),
      inputValue: this.getMinQuantity(),
      showMeasurementUnit: ws_vue_store.show_measurement_unit == '1' ? true : false,
      translations: {
        addToCart: ws_vue_store.translations.add_to_cart,
        invalidMessage: ws_vue_store.translations.add_to_cart_invalid_message
      }
    };
  }
};
</script>
